import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import DOMPurify from 'dompurify';
import { Elevation, Grid, GridCell, Button, Typography, Icon } from 'rmwc';

import { currencyFormatter, Money } from '../../components/Money';

import { runFullSimulation } from '../../actions/simulationActions';
import { Text } from '../../components/Text';
import { withRegistrationDialog } from '../../components/RegistrationDialog';
import { withEmailDialog } from '../../components/EmailDialog';

import LetterScore from '../../components/charts/LetterScore';
import AssetBalanceChart from '../../components/charts/AssetBalanceChart';

import { fetchDashboard } from '../../actions/dashboardActions';
import { fetchPeople } from '../../actions/peopleActions';
import { fetchSavingsModule } from '../../actions/savingsActions';

import FinancialShockSidebar from './FinancialShockSidebar';

import { CTAOpt } from '../../components/Onboarding/CtaVariants';
import { PlanCTA } from '../Onboarding/PlanIntro';

import { updateTools } from '../../actions/toolsActions';
import { updateFrame } from '../../actions/uiActions';

import {
  MTHeader,
  MTSkinny,
  MTSubheading,
  MTSubcontent,
  MTSubcontentP,
  MTDivider,
  MTSubcontentHR,
  MTSubcontentH1,
  MTSubcontentH2,
  MTSubcontentLabel,
  MTScorePanel,
  MTCTA,
  MTCTAv2,
  MTLearnMore,
  MTLearnMoreItem,
} from './layout';
import { wlPath } from '../../helpers/whitelabel';

export class ContentPage extends Component {
  componentWillMount() {
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    // if (!this.props.results) {
    //   this.props.runFullSimulation();
    // }
    this.fetchData();
    const content = this.getContent();
    this.props.updateTools({
      active: content.page_impact_label,
      dollarsGained: content.page_impact_amount,
    });

    this.props.updateFrame(content.title, content.page_background_image_name);
  }

  getContent = () => {
    const pageSlug = this.props.match.path.split('/')[3];
    for (let opt of this.props.contentPages) {
      if (opt.url_slug == pageSlug) {
        return opt;
      }
    }
  };

  fetchData = () => {
    this.props.fetchSavingsModule();
    this.props.fetchPeople();
  };

  calcRetirementFeeSaving = () => {
    if (this.props.updatedResults && this.props.people) {
      const primaryAge = this.props.people[0].age;
      const retirementAge = 67;
      const yearsUntilRetirement = retirementAge - primaryAge;
      // person already retired
      if (yearsUntilRetirement <= 0) {
        return 0;
      }
      const savingsAmount =
        this.props.results.distribution.asset_balance.average[yearsUntilRetirement - 1] -
        this.props.updatedResults.distribution.asset_balance.average[yearsUntilRetirement - 1];
      return savingsAmount;
    }
    return 0;
  };

  render() {
    const { people, results, onContinue, openRegistrationDialog, openEmailDialog, history, savings } = this.props;

    const moneyLastsUntilAge = year => people[0].age + (year - new Date().getFullYear());

    const content = this.getContent();

    if (!results || !savings) {
      return null;
    }

    const sanitizeInput = () => {
      return {
        __html: DOMPurify.sanitize(
          content.page_impact_description.replace(
            '{DOLLARS_GAINED}',
            `<strong><span style="color:#10cf9b;">${currencyFormatter(content.page_impact_amount, 0)}</span></strong>`
          )
        ),
      };
    };

    return (
      <div>
        <MTHeader title="" onClick={() => history.push(wlPath('/action-plan'))} />
        <MTSkinny>
          <MTSubheading title={content.page_detail_heading} />
          <MTSubcontent noCard>
            <MTSubcontentP last>{content.page_detail_body}</MTSubcontentP>
          </MTSubcontent>
        </MTSkinny>
        <MTDivider />
        <MTSkinny>
          <MTSubheading title="How much could this impact your retirement?" />
          <MTSubcontent noCard>
            <MTSubcontentP>
              <div dangerouslySetInnerHTML={sanitizeInput()} />
            </MTSubcontentP>
            <MTSubcontentP last>{content.page_impact_methodology}</MTSubcontentP>
          </MTSubcontent>
        </MTSkinny>
        <PlanCTA />
      </div>
    );
  }
}

function getPrimaryPerson(people, dashboard) {
  if (!people.fetched || !dashboard.fetched) {
    return null;
  }
  for (const person of people.data) {
    if (person.id == dashboard.data.primary_person_id) {
      return person;
    }
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
    people: state.people.data,
    results: state.simulations.results,
    primaryPerson: getPrimaryPerson(state.people, state.modules.dashboard),
    updatedResults: state.modules.dashboard.simulation ? state.modules.dashboard.simulation.results : null,
    savings: state.modules.savings.data,
    contentPages: state.contentPages.data,
  };
}

function mapDispatchToProps() {
  return {
    runFullSimulation,
    fetchDashboard,
    fetchPeople,
    fetchSavingsModule,
    updateFrame,
    updateTools,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(withEmailDialog(withRegistrationDialog(ContentPage)));
